import { server } from '../helpers';

export const getGiftCard = (code) =>
  server.request
    .get(`/giftcard`, { params: { code: encodeURIComponent(code) } })
    .then(server.handleSuccess)
    .catch(server.handleError);
